import React from 'react'
import propTypes from '@dhis2/prop-types'

export function Apps({ className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            className={className}
        >
            <path d="M8 16h8V8H8v8zm12 24h8v-8h-8v8zM8 40h8v-8H8v8zm0-12h8v-8H8v8zm12 0h8v-8h-8v8zM32 8v8h8V8h-8zm-12 8h8V8h-8v8zm12 12h8v-8h-8v8zm0 12h8v-8h-8v8z" />
            <path d="M0 0h48v48H0z" fill="none" />
        </svg>
    )
}
Apps.propTypes = {
    className: propTypes.string,
}
